import { motion } from "framer-motion";

interface PageContainerProps {
  children: React.ReactNode;
  noNav?: boolean;
}

export const PageContainer = ({ children, noNav = false }: PageContainerProps) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.25 }}
    className={`min-h-screen bg-ground ${noNav ? "pb-8" : "pb-24"}`}
  >
    {children}
  </motion.div>
);
